import React from "react";
import PropTypes from "prop-types";
import { getTrueClasses } from "../../../../../../../helpers";
import TitleCategory from "./TitleCategory";
import Link from "./Link";

const Category = ({ category, links, icon, index }) => {
  return (
    <div className={getTrueClasses("GCL-H-T-T-C", `GCL-H-T-T-C_c${index + 1}`)}>
      {category && <TitleCategory title={category} icon={icon} />}
      <div className="GCL-H-T-T-C-list">
        {links.map((linkProps, i) => (
          <Link key={i} {...linkProps} />
        ))}
      </div>
    </div>
  );
};
Category.propTypes = {
  links: PropTypes.array,
  category: PropTypes.string,
  index: PropTypes.number,
};

export default Category;
